import { render, staticRenderFns } from "./searchHeader.vue?vue&type=template&id=f0524196&scoped=true&"
import script from "./searchHeader.vue?vue&type=script&lang=ts&"
export * from "./searchHeader.vue?vue&type=script&lang=ts&"
import style0 from "./searchHeader.vue?vue&type=style&index=0&id=f0524196&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0524196",
  null
  
)

export default component.exports